import { create } from 'zustand';
import { ExistingProfile } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/types/profileTypes';

interface ProfileImportState {
  isSelectProfileModalOpen: boolean;
  importedProfile: ExistingProfile | null;
  openSelectProfileModal: () => void;
  closeSelectProfileModal: () => void;
  setImportedProfile: (profile: ExistingProfile) => void;
  clearImportedProfile: () => void;
}

export const useProfileImportStore = create<ProfileImportState>((set) => ({
  isSelectProfileModalOpen: false,
  importedProfile: null,
  openSelectProfileModal: () => set({ isSelectProfileModalOpen: true }),
  closeSelectProfileModal: () => set({ isSelectProfileModalOpen: false }),
  setImportedProfile: (profile: ExistingProfile) => set({ importedProfile: profile }),
  clearImportedProfile: () => set({ importedProfile: null })
})); 